<div class="auth-page-wrap">

    <div class="auth-page-body">

        <div class="auth-panel" @fadeIn>

            <logo class="auth-header-logo">
            </logo>

            <div class="auth-body">

                <div class="auth-body-top">

                    <div class="auth-body-title rpc-title-font">
                        {{ 'FORGOT_PASSWORD.TITLE' | translate }}
                    </div>

                    <div class="auth-body-text">
                        {{ 'FORGOT_PASSWORD.RESET_EXPLANATION' | translate }}
                    </div>

                </div>

                <form class="auth-form" name="forgotPasswordForm" [formGroup]="forgotPasswordForm" novalidate>

                    <div class="auth-form-body">

                        <rpc-input class="auth-form-input" [type]="'email'" [appearance]="'fill'"
                            [autocomplete]="'email'" [label]="'FORGOT_PASSWORD.FIELDS.EMAIL'"
                            [options]="userNameControlOptions">
                        </rpc-input>

                    </div>

                    <div class="auth-form-footer">

                        <rpc-button [color]="'accent'" [isMainButton]="true" [disabled]="forgotPasswordForm.invalid"
                            [appearanceType]="'flat'" [text]="'FORGOT_PASSWORD.SEND_BUTTON'" (clicked)="sendEmail()">
                        </rpc-button>

                        <rpc-button class="auth-form-footer-back" [isMainButton]="true" [link]="'/' + RpcRoute.Login"
                            [appearanceType]="'flat'" [text]="'FORGOT_PASSWORD.BACK_TO_LOGIN'">
                        </rpc-button>

                    </div>

                </form>

            </div>

        </div>

    </div>

</div>

<additional-footer class="global-additional-footer">
</additional-footer>